import { render, staticRenderFns } from "./ModalDeletePackage.vue?vue&type=template&id=6cfaebe1"
import script from "./ModalDeletePackage.vue?vue&type=script&lang=js"
export * from "./ModalDeletePackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports